import React from 'react';
import styled from 'styled-components';
import flattenFragment from '../../utils/flattenFragment';

export default function Stack({
  space = 'none',
  align = 'left',
  children,
  ...props
}) {
  return (
    <Container align={align} {...props}>
      {React.Children.map(flattenFragment(children), item => item !== null && item !== '' ? (
        <Element space={space} align={align}>{item}</Element>
      ) : null)}
    </Container>
  )
}

const flexAlignments = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => flexAlignments[props.align]};
`;

const Element = styled.div`
  display: flex;
  justify-content: ${props => flexAlignments[props.align]};
  width: 100%;
  padding-bottom: ${props => props.theme.tokens.space[props.space]}rem;

  &:last-child {
    padding-bottom: 0;
  }
`;
